export default __webpack_public_path__ + "static/media/dancing-script-latin-500.83f51239.woff2";